import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { ColorChecker } from '../../Helpers/Functions/ColorChecker.js';

export default function Sponsorship({
    users,
    visibleFields,
    team,
    custom_field_values,
    user_avatars,
    logo,
    page,
    amounts,
}) {
    const [fieldValues, setFieldValues] = useState(custom_field_values)
    const [truncateId, setTruncateId] = useState(0)
    const [truncateUserId, setTrucateUserId] = useState(0)
    const [currentSelection, setCurrentSelection] = useState(null)
    const [buttonTextColor, setButtonTextColor] = useState('white')
    const [buttonColor, setButtonColor] = useState(page.button_color)

    useEffect(() => {
        let result = ColorChecker(buttonColor)
        if (result == true) setButtonTextColor('black')
    }, [])

    function canShowPublicField(customFields, field) {
        const foundField = customFields.find(
          (f) => f.system_key === field.toString()
        );
        return foundField && foundField.visible;
      }
    
      const getFieldValues = (user, field) => {
        if (field.system_key == 'bio') return user.bio
        const userRecords = [];
    
        for (const innerArray of fieldValues) {
            const matchingRecords = innerArray.filter(value => value.record_id == user.id);
            userRecords.push(...matchingRecords);
        }
        if (!userRecords) return null
    
        let valueObject = userRecords.find(record => record.team_custom_field_id == field.id)
        if (valueObject) return valueObject.value 
        return null
      }
    
      const getUserAvatar = (user) => {
        const matchingRecord = user_avatars.find(
          (record) => record.user_id === user.id
        );
    
        if (matchingRecord.user_avatar != null) {
          return matchingRecord.user_avatar;
        }
      };
    
      const defineAge = (birthday) => {
        if (!birthday) {
          return "";
        }
        const age = Math.floor(
          (new Date() - new Date(birthday)) / (365 * 24 * 60 * 60 * 1000)
        );
        return age.toString();
      };
    
      const getAmounts = (amount = null) => {
        if (amount) {
          if (page.pass_processing_fee) {
            let raw_amount = parseFloat(amount.amount)
            let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
            let total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
            return total;
          }
          return amount.amount;
        } else {
          if (page.pass_processing_fee) {
            let raw_amount = page.general_sponsorship_amount
            let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
            let total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
            return total;
          }
    
          return page.general_sponsorship_amount;
        }
      };

      const truncateTest = (text, id, user_id) => {
        if (text.length > 200) {
            if (truncateId != id || truncateUserId != user_id) return text.substring(0, 200) + '...'
            if (truncateId == id && truncateUserId == user_id) return text
        } else {
            return text
        }
      }

      const unpaidSponsorshipsCount = (id) => {
        let sponsorships = amounts.filter(amount => amount.user_id == id && !amount.paid)
        return sponsorships.length > 0 ? sponsorships.length : 1
      }

      const totalSponsorshipCount = (id) => {
        let sponsorships = amounts.filter(amount => amount.user_id == id)
        return sponsorships.length > 0 ? sponsorships.length : 1
      }

      const userSponsorshipAmount = (user) => {
        let sponsorships = amounts.filter(amount => amount.user_id == user.id && !amount.paid)
        return sponsorships.length > 0 ? sponsorships : false
      }
    
      const handleInputChange = (value) => {
          setCurrentSelection(value)
      }
    
      const handleStaticChange = (value) => {
    
      }
    
      const visitSponsorPage = (user) => {
          let userSponsorships = amounts.filter(amount => amount.user_id == user.id && !amount.paid)
          if (!userSponsorships || (userSponsorships && userSponsorships.length < 1)) {
              window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new`
              return
          } else {
              let sponsorshipsWithId = userSponsorships.filter(amount => currentSelection && amount.id == currentSelection.id)
              if (sponsorshipsWithId && sponsorshipsWithId.length > 0) {
                  window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new?sponsorship_id=${sponsorshipsWithId[0].id}`
                  return
              } else {
                  window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new?sponsorship_id=${userSponsorships[0].id}`
                  return
              }
          }
      }

  return (
    <div class="row row-projects">
        {users && users.map(user => {
            let avatar = getUserAvatar(user);
            return (
                <div class='col-sm-6 col-lg-3' key={user.id}>
                    <div className='card'>
                        {avatar && (
                            <div className="p-2">
                                <img
                                src={avatar}
                                className="card-img-top rounded"
                                />
                            </div>
                        )}

                        <div className='card-body pt-2'>
                            <div class="card-body pt-2">
                                <h4 className="mb-1 fw-bold">
                                    {canShowPublicField(visibleFields, "first_name") &&
                                    `${user.first_name} `}

                                    {canShowPublicField(visibleFields, "last_name") &&
                                    `${user.last_name}`}
                                </h4>

                                {canShowPublicField(visibleFields, "birthday") &&
                                    user.birthday != null &&
                                    <p className='text-muted small mb-2'>
                                        {user.birthday + " (" +
                                         defineAge(user.birthday) + " years old)"
                                        }
                                    </p>
                                }

                                {visibleFields.map((field) => {
                                    if (
                                        field.system_key === "first_name" ||
                                        field.system_key === "last_name" ||
                                        field.system_key === "birthday"
                                    ) {
                                        return null;
                                    }

                                    const value = getFieldValues(user, field);
                                    return (
                                      <div>
                                        {value != "" && (
                                            <div key={field.id}
                                            className="mb-2 sponsorship-template-fields"
                                            >
                                                <p className="text-bold small mb-2">
                                                {field.name}
                                                </p>
                                                {value && field.value_type == 'link' &&
                                                    <a href={value} target='_blank'>{ field.anchor_text ? field.anchor_text : field.name }</a>
                                                }
                                                {value && field.value_type !== 'link' &&
                                                    <p className="text-muted small">
                                                        {truncateTest(value, field.id, user.id)}
                                                        {truncateTest(value, field.id, user.id).length <= 203 && 
                                                         value.length > 200 &&
                                                            <span 
                                                                className='text-blue' 
                                                                onClick={() => { setTruncateId(field.id); setTrucateUserId(user.id)} }
                                                                style={{cursor: 'pointer', color: 'blue'}}
                                                            > 
                                                                {' show more' }
                                                            </span>
                                                        }
                                                        {truncateTest(value, field.id, user.id).length > 203 &&
                                                            <span 
                                                                className='text-blue' 
                                                                onClick={() => {setTruncateId(0); setTrucateUserId(0)}} 
                                                                style={{cursor: 'pointer', color: 'blue'}}
                                                            > 
                                                                {' show less'}
                                                            </span>
                                                        }
                                                    </p>
                                                } 
                                                {!value && field.system_key == 'bio' &&
                                                    <p className="text-muted small">
                                                        No data available.
                                                    </p>
                                                }
                                            
                                          </div>
                                        )}
                                      </div>
                                    )
                                })}

                                {page.general_sponsorship_amount && unpaidSponsorshipsCount(user.id) > 1 &&
                                    <p className='mb-0' style={{fontSize: '13px', textAlign: 'center'}}>
                                        <b>{`${unpaidSponsorshipsCount(user.id)} of ${totalSponsorshipCount(user.id)} sponsorships available`}</b>
                                    </p>
                                }

                                {page.general_sponsorship_amount && userSponsorshipAmount(user) && userSponsorshipAmount(user).length > 1 &&
                                    <div className='form-group'>
                                        <div className="input-group">
                                            <Select
                                                className="w-100 select-audience"
                                                classNamePrefix="select-audience"
                                                value={currentSelection ? currentSelection : userSponsorshipAmount(user)[0]}
                                                onChange={(value) => handleInputChange(value)}
                                                options={userSponsorshipAmount(user)}
                                                getOptionLabel={option => `$${getAmounts(option)} / Month`}
                                                getOptionValue={option => option.id }
                                            />
                                        </div>
                                    </div>
                                }

                                {/* Only one sponsorship amount available */}
                                {page.general_sponsorship_amount && userSponsorshipAmount(user) && userSponsorshipAmount(user).length == 1 &&
                                    <div className='mt-3' style={{textAlign: 'center'}}>
                                        <h5>Sponsor: {`$${getAmounts(userSponsorshipAmount(user)[0])} / Month`}</h5>
                                    </div>
                                }
                                
                                {page.general_sponsorship_amount && !userSponsorshipAmount(user) &&
                                    <div className='mt-3' style={{textAlign: 'center'}}>
                                        <h5>Sponsor: {`$${getAmounts()} / Month`}</h5>
                                    </div>
                                }

                                <a className="btn btn-sm btn-primary mt-3"
                                    href='#'
                                    onClick={() => visitSponsorPage(user)}
                                    style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}
                                >
                                    {page.button_text && <>{page.button_text}</>}
                                    {!page.button_text && <>Sponsor</>}
                                </a>
                                
                            </div>
                        </div>
                    </div>
                </div>
            );
        })}
    </div>
  )
}
